document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;

  const nav = document.querySelector('[data-site-nav]');
  if (!nav) return;

  const isOpen = nav.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', String(isOpen));
});

document.querySelectorAll('[data-hero-slideshow]').forEach((hero) => {
  const slides = Array.from(hero.querySelectorAll('.hero__slide'));
  if (slides.length < 2) {
    slides[0]?.classList.add('is-active');
    return;
  }

  let activeIndex = 0;
  const duration = Number(hero.dataset.slideDuration || 5) * 1000;
  slides[activeIndex].classList.add('is-active');

  window.setInterval(() => {
    slides[activeIndex].classList.remove('is-active');
    activeIndex = (activeIndex + 1) % slides.length;
    slides[activeIndex].classList.add('is-active');
  }, duration);
});
